/**
 * One Material Symbols glyph.
 *
 * THE SET GOOGLE DOCS USES. @mui/icons-material ships Material *Icons* -- the older, heavier,
 * filled family -- and beside a Docs window the difference reads instantly: thicker strokes,
 * filled counters, and in several cases a different glyph for the same idea. Symbols is the
 * current set and a VARIABLE font, so weight and optical size are CSS rather than a choice of
 * export.
 *
 * A LIGATURE, NOT A COMPONENT PER ICON. The font renders the glyph from its name, so adding one is
 * a string rather than an import -- which is why a toolbar of thirty icons does not become thirty
 * imports kept in step with thirty usages.
 *
 * `display=block` ON THE STYLESHEET matters: with the default swap behaviour the browser paints the
 * LIGATURE TEXT -- the literal words "format_bold" -- for the moment before the font arrives, so a
 * cold load flashes a toolbar of English words. Block shows nothing until it is ready.
 */
import React from "react";
import { Box } from "@mui/material";

export default function Symbol({ name, size = 20, colour, weight = 400, fill = 0, sx }: {
    name: string;
    size?: number;
    colour?: string;
    weight?: number;
    /** 1 draws the solid version -- used for a control that is ON. */
    fill?: 0 | 1;
    sx?: any;
}) {
    return (
        <Box component="span" aria-hidden="true" sx={{
            fontFamily: "'Material Symbols Outlined'",
            fontWeight: "normal", fontStyle: "normal",
            fontSize: size, lineHeight: 1, letterSpacing: "normal",
            textTransform: "none", display: "inline-block", whiteSpace: "nowrap",
            wordWrap: "normal", direction: "ltr",
            // The variable axes. opsz tracks the rendered size, which is what keeps a 20px glyph
            // from looking like a shrunken 48px one.
            fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
            color: colour,
            userSelect: "none",
            ...sx,
        }}>{name}</Box>
    );
}
